import React from 'react'
import './detailDrawer.scss'

export interface DetailItemProps {
  label: string
  value?: React.ReactNode
  full?: boolean
  bold?: boolean
  highlight?: boolean
}
const DetailItem: React.FC<DetailItemProps> = ({
  label,
  value,
  full,
  bold,
  highlight
}) => (
  <div
    className={`detail-drawer__item${full ? ' detail-drawer__item--full' : ''}${
      highlight ? ' detail-drawer__item--highlight' : ''
    }`}
  >
    <span className="detail-drawer__label">{label}</span>
    <span
      className={`detail-drawer__value${
        bold ? ' detail-drawer__value--bold' : ''
      }`}
    >
      {value ?? '-'}
    </span>
  </div>
)

export default DetailItem
